import React from 'react';
import PropTypes from 'prop-types';
import styles from './header2.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { HeaderNavigationPropTypes } from './quarks/header-navigation/header-navigation-proptypes.js';
import { HeaderNavigation } from './quarks/header-navigation/header-navigation.js';
import { Overlay } from '../overlay/overlay.js';
import { Injecss } from '../../packages/injecss/injecss.js';
import Icon from '../icon/icon.js';
import { IconBurger } from '../icons/inline/icon-burger.js';

var bem = HoneyBem('header', styles);
var bemBrand = HoneyBem('header-brand', styles);
var bemToggler = HoneyBem('header-nav-toggle', styles);
var bemNavWrapper = HoneyBem('header-nav-wrapper', styles);
var bemWidget = HoneyBem('header-widgets', styles);
var Header = function Header(_ref) {
  var extraClasses = _ref.extraClasses,
      brand = _ref.brand,
      fixed = _ref.fixed,
      fullwidth = _ref.fullwidth,
      menuVisible = _ref.menuVisible,
      navigation = _ref.navigation,
      toggleMenu = _ref.toggleMenu,
      mobileWidget = _ref.mobileWidget,
      widget = _ref.widget,
      stickyWidget = _ref.stickyWidget;
  return (// forcing header to become fixed if mobile side menu is visible,
    // preventing menu control scrolling out of view
    React.createElement("header", {
      className: bem.b({
        unfixed: !fixed && !menuVisible,
        fullwidth: fullwidth
      }, extraClasses)
    }, React.createElement("div", {
      className: bem.e('inner')
    }, (navigation.length >= 1 || widget || mobileWidget) && React.createElement("button", {
      onClick: toggleMenu,
      type: "button",
      className: bemToggler.b()
    }, React.createElement(Icon, {
      InlineIcon: IconBurger
    })), React.createElement("div", {
      className: bemBrand.b({
        square: brand.square
      })
    }, React.createElement("a", {
      className: bemBrand.e('link'),
      href: brand.href
    }, React.createElement("img", {
      className: bemBrand.e('img'),
      src: brand.image,
      alt: brand.alt
    }))), React.createElement("div", {
      className: HoneyBem('header-navbar', styles).b()
    }, (navigation.length >= 1 || widget || mobileWidget) && React.createElement(React.Fragment, null, React.createElement("div", {
      className: menuVisible ? bemNavWrapper.b('visible') : bemNavWrapper.b()
    }, navigation.length > 0 && React.createElement(HeaderNavigation, {
      navigation: navigation
    }), widget && !stickyWidget && React.createElement("div", {
      className: bemWidget.b('mobile')
    }, widget), mobileWidget && React.createElement("div", {
      className: bemWidget.b('mobile')
    }, mobileWidget)), React.createElement(Overlay, {
      extraClasses: HoneyBem('header-navbar', styles).e('overlay')
    }))), widget && React.createElement("div", {
      className: stickyWidget ? bemWidget.b('sticky') : bemWidget.b()
    }, widget)))
  );
};
Header.displayName = 'Header';
Header.defaultProps = {
  extraClasses: '',
  navigation: [],
  toggleMenu: function toggleMenu() {},
  menuVisible: false,
  mobileWidget: false,
  widget: false,
  fixed: true,
  fullwidth: false,
  stickyWidget: false
};
Header.propTypes = {
  /** Properties for the brand logo:
   * image - URL of your brand image,
   * alt - respective alt for provided image,
   * href - href for the logo link,
   * square - defines if the logo needs to have square sized styles */
  brand: PropTypes.shape({
    image: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    square: PropTypes.bool
  }).isRequired,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Array used to construct the navigation, has following structure:
   * `content` - defines link text,
   * `children` - sub navigation menu items (array with the same structure should be provided),
   * `current` - defines if this item is the current active one,
   * `component` - pass custom component if you need support for ReactRouter or similar libraries,
   */
  navigation: HeaderNavigationPropTypes,

  /** Click handler for burger menu (show/hide on mobile) */
  toggleMenu: PropTypes.func,

  /** Controls visibility of the menu */
  menuVisible: PropTypes.bool,

  /** Widget for the header,
   * this gets duplicated into mobile side nav as well by default */
  widget: PropTypes.node,

  /** Widget for the mobile side navigation,
   * use that if you want something to be present in side nav only */
  mobileWidget: PropTypes.node,

  /** Disable widget collapsing into mobile menu */
  stickyWidget: PropTypes.bool,

  /** Set the header to be fixed */
  fixed: PropTypes.bool,

  /** Makes header contents to occupy full screen width  */
  fullwidth: PropTypes.bool
};
var header = Injecss(Header, styles);

export default header;
export { Header };
